import * as d3 from "d3";
import "./D3RepPerformanceBar.scss";
import {
  customTickFormat,
  stageFormattter,
} from "../../../util/customFunctions";
import { store } from "../../../util/store";
const D3RepPerformanceBar = {};
const _isNaN = function (value) {
  var n = Number(value);
  return n !== n;
};
// to increase the spacing between the bar increase this PADDING_BETWEEN_BARS_CONSTANT
const PADDING_BETWEEN_BARS_CONSTANT = 40;
D3RepPerformanceBar.create = (el, config) => {
  const Symbol = store.getState();
  const Currency_Symbol = Symbol.app.user.Currency;

  d3.selection.prototype.last = function () {
    return d3.select(this.nodes()[this.size() - 1]);
  };

  if (config.data) {
    config.data = config.data.filter((item) => item.Name !== "total");
    config.barColor = "#70ad47";
    config.barHeight = 10;
    var marginLeftCalc = config.data;

    config.margin = {
      top: 20,
      right: 20,
      bottom: 120,
      left:
        marginLeftCalc.sort((a, b) => b.Name.length - a.Name.length)[0].Name
          .length * 7.3,
    };
    if (!config.width) {
      config.width = d3.select(el).node()
        ? d3.select(el).node().getBoundingClientRect().width -
        config.margin.left -
        config.margin.right
        : 50;
    }
    config.height = config.data.length * PADDING_BETWEEN_BARS_CONSTANT; // to increase the spacing between the bar increase this PADDING_BETWEEN_BARS_CONSTANT
    const wonLabel = config.label.filter((item) => item.type === "won")[0]
      .label;

    config.data = config.data
      .map((item) => ({
        closedWon: _isNaN(parseFloat(item[`${wonLabel}_ACV`]))
          ? 0
          : parseFloat(item[`${wonLabel}_ACV`]),
        rep: item.Name,
        quota: _isNaN(parseFloat(item.Quota)) ? 0 : parseFloat(item.Quota),
        attainment: _isNaN(parseFloat(item.attainment))
          ? 0
          : parseFloat(item.attainment),
      }))
      .filter((item) => item.rep !== "total");
    var data = config.data.sort((a, b) => b.attainment - a.attainment);

    const y = d3
      .scaleBand()
      .rangeRound([0, config.height])
      .padding(0.534482775);

    const x = d3.scaleLinear().range([config.width, 0]);

    const xAxis = d3
      .axisBottom(x)
      .tickFormat((d) =>
        d !== 0
          ? `${Currency_Symbol}${d3.format(".2s")(d)}`.toUpperCase()
          : null
      )
      .ticks(8);

    const yAxis = d3.axisLeft(y);
    y.domain(
      data.map((d) => {
        return d.rep;
      })
    );

    x.domain([
      d3.max([...data.map((d) => d.closedWon), ...data.map((d) => d.quota)]) +
      d3.max([...data.map((d) => d.closedWon), ...data.map((d) => d.quota)]) *
      0.1,
      0,
    ]);

    function make_x_gridlines() {
      return d3.axisBottom(x).ticks(8);
    }

    // gridlines in y axis function
    function make_y_gridlines() {
      return d3.axisLeft(y).ticks(5);
    }

    var xAxisHeight = config.height;
    const chart = d3
      .select(el)
      .append("svg")
      .attr("width", config.width + config.margin.left + config.margin.right)
      .attr("height", config.height + config.margin.top + config.margin.bottom)
      .append("g")
      .attr(
        "transform",
        `translate(${config.margin.left},${config.margin.top})`
      );
    var legend = d3.select(el).append("div").attr("class", "legend");

    chart
      .append("g")
      .attr("class", "grid")
      .attr("transform", "translate(0," + config.barHeight + ")")
      .attr("z-index", -1)
      .call(make_x_gridlines().tickSize(xAxisHeight).tickFormat(""));

    // add the Y gridlines
    // chart
    //     .append("g")
    //     .attr("class", "grid")
    //     .attr("z-index", -1)
    //     .call(make_y_gridlines().tickSize(-config.width).tickFormat(""));

    chart
      .append("g")
      .attr("class", "xaxis")
      .attr("transform", "translate(0," + xAxisHeight + ")")
      .call(xAxis);

    chart.append("g").attr("class", "yaxis").call(yAxis);
    var bars = chart.selectAll(".bar").data(data).enter().append("g");

    // Quota bar (background - #BF9000 with opacity) - taller/wider
    bars
      .append("rect")
      .attr("stroke", "#00000")
      .attr("fill", "#BF9000")
      .attr("opacity", 0.3)
      .attr("y", (d) => y(d.rep) - 4)
      .attr("height", y.bandwidth() / 2.25 + 20)
      .attr("x", 0)
      .attr("width", function (d) {
        return x(d.quota);
      });

    // Actual ACV bar (foreground - #70AD47) - smaller, centered in quota bar
    bars
      .append("rect")
      .attr("class", "bar")
      .attr("stroke", "#00000")
      .attr("fill", "#70AD47")
      .attr("y", (d) => y(d.rep))
      .attr("height", y.bandwidth() / 2.25 + 12)
      .attr("x", 0)
      .attr("width", function (d) {
        return x(d.closedWon);
      });

    //add a value label inside the bar (positioned near the left edge)
    bars
      .append("text")
      .attr("class", "label")
      //y position of the label is halfway down the bar
      .attr("y", function (d) {
        return y(d.rep) + y.bandwidth() / 2.25 + 4;
      })
      //x position is a few pixels from the left edge (inside the bar)
      .attr("x", function (d) {
        return 5;
      })
      .attr("dy", "0.1rem")
      .text(
        (d) =>
          `${Currency_Symbol}${_isNaN(d.closedWon) ? 0 : d3.format(",")(Math.round(d.closedWon))
          } (${_isNaN(d.attainment) ? 0 : Math.round(d.attainment * 100)}%)`
      )
      .style("font-weight", 500)
      .attr("fill", "#404040");
    chart
      .append("text")
      .attr("y", xAxisHeight + 30)
      .attr("x", config.width / 2 - 80)
      .attr("dy", "1em")
      .attr("class", "axis-label")
      .attr("font-size", "0.85rem")
      // .attr("font-weight", "500")
      .attr("fill", "#000000")
      .text(`${wonLabel.split("_").join(" ")} ${config.Value_Label}`);

    // Add legend
    var legends = legend
      .selectAll("div")
      .data([
        { text: `${wonLabel.split("_").join(" ")} ${config.Value_Label}`, color: "#70AD47" },
        { text: "Attain.%", color: "#BF9000" },
      ])
      .enter()
      .append("div")
      .attr("class", "legend-flex");
    legends
      .append("div")
      .attr("class", "legends")
      .style("align-items", "end")
      .style("background-color", (d) => d.color)
      .style("opacity", (d) => (d.color === "#BF9000" ? 0.3 : 1));
    legends
      .append("div")
      .text((d) => d.text)
      .style("padding-left", "1rem")
      .style("min-width", "10rem")
      .style("max-width", "10rem");

    legend
      .attr("width", config.width)
      .attr("height", config.height)
      .attr("class", "legend-flex")
      .style("justify-content", "center")
      .selectAll(".legends")
      .data(["one", "two"])
      .enter()
      .append("div")
      .attr("class", "legends")
      .style("background-color", (d) => "blue")
      .html((d) => `<div></div>`);
  }
};
D3RepPerformanceBar.destroy = (el) => {
  d3.select(el).selectAll("svg").remove();
  d3.select(".legend-flex").remove();
};
export default D3RepPerformanceBar;
